import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import SingleCard from "../components/SingleCard";
import axios from "axios";

function Uxui() {
  const [visibleCards, setVisibleCards] = useState(100);
  const [shuffledData, setShuffledData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://devuse-fullstack.vercel.app/tools/all-tools"
        );
        const allData = response.data;

        const webDevData = allData.filter((item) =>
          item.toolTag.includes("UX UI")
        );

        const shuffledWebDevData = shuffleArray(webDevData);

        setShuffledData(shuffledWebDevData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const cardLoading = Array(visibleCards).fill(true);

  const shuffleArray = (array) => {
    const newArray = [...array];
    const newTools = newArray.filter((item) => item.toolType).reverse();
    const otherCards = newArray.filter((item) => !item.toolType);
    const shuffledOtherCards = shuffleArrayHelper(otherCards);
    const shuffledArray = [...newTools, ...shuffledOtherCards];

    return shuffledArray;
  };

  const shuffleArrayHelper = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };

  
  const handleToolClick = (toolId) => {
    axios
      .post(`https://devuse-fullstack.vercel.app/tools/click/${toolId}`)
      .then((response) => {
        console.log(response.data.message);
        axios
          .get("https://devuse-fullstack.vercel.app/tools/all-tools")
          .then((response) => {
            const allData = response.data;
            const webDevData = allData.filter((item) =>
              item.toolTag.includes("UX/UI")
            );
            const shuffledWebDevData = shuffleArray(webDevData);

            setShuffledData(shuffledWebDevData);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      })
      .catch((error) => {
        console.error("Error updating click count:", error);
      });
  };

  return (
    <div className="top-spacing">
      <Grid container justifyContent={"flex-start"} gap={2}>
        <Grid item xs={12} lg={10.4}>
          {shuffledData.length > 0 && (
            <Grid container justifyContent={"center"} gap={2}>
              {shuffledData.map((item, index) => (
                <Grid item xs={10} sm={6} md={4} lg={3} key={index}>
                  <SingleCard
                     ImageSrc={item.backgroundImageUrl}
                     title={item.toolTitle}
                     description={item.toolDescription}
                     websiteLink={item.toolLink}
                     tag={item.toolTag}
                     type={item.toolType}
                     clicked={item.clicks}
                     handleClick={() => handleToolClick(item._id)}
                  />
                </Grid>
              ))}
            </Grid>
          )}
          <Grid container justifyContent={"center"} gap={2}>
            {shuffledData.length === 0 &&
              cardLoading.map((_, index) => (
                <Grid item xs={10} sm={6} md={4} lg={3} key={index}>
                  <div className="card_loader" />
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default Uxui;
